export const iconFontAwesomeEducationMicroscope = (
	<i className="fa-solid fa-microscope"></i>
);
